import React, { useRef } from 'react'
import { useAuthDataContext } from '../../../../_providers/Auth'
import Dropdown from '../../../partials/Dropdown'
import { trans } from '../../../../_providers/Translation'
import DateRange from '@/components/partials/DateRange'
import { Checkbox, FormControlLabel } from '@mui/material'

function Filter(props) {
    const empoyeesDropdownRef = useRef(null)

    const auth = useAuthDataContext()

    const handleSearch = e => {
        let name = e.target.name
        let val = e.target.value

        props.handleSearch(name, val)
    }

    const handleDate = e => {
        let name = e.target.name
        let val = e.target.value

        props.handleSearch(name, val)
    }

    const handleUser = data => {
        let val = data.id || ''

        props.handleSearch('user_id', val)
    }

    const handleSelectMobileFilter = e => {
        let selectedValue = e.target.value
        let fields = [...document.querySelectorAll('.filter-standard .col')]
        fields.map(field => {
            if (field.getAttribute('data-id') == selectedValue) field.style.display = 'flex'
            else if (field.getAttribute('data-id')) field.style.display = 'none'
        })
    }

    const handleClearFilters = () => {
        props.handleSearch('date', '')
        empoyeesDropdownRef.current.reset()
        props.handleSearch('user_id', '')
        props.handleSearch('deadline', '')
        props.handleSearch('text', '')
        props.handleSearch('flagged', '0')
    }

    return (
        <form className="filter-standard schedule-filter">
            <div className="col select-filter-col">
                <label>
                    {trans('filters.filterBy')}
                </label>
                <select onChange={handleSelectMobileFilter}>
                    <option value="1" selected>
                        {trans('labels.contractor')}
                    </option>
                    <option value="2">
                        {trans('labels.from')}
                    </option>
                    <option value="3">
                        {trans('labels.to')}
                    </option>
                    <option value="4">
                        {trans('labels.search')}
                    </option>

                </select>
            </div>

            {auth.isManager()
                ?
                <div className="col" data-id="1">
                    <Dropdown
                        url="partners/employees/all"
                        inputIdValue={props.data.user_id ? Number(props.data.user_id) : ''}
                        renderText={data => {
                            return `${data.name} ${data.lastname}`
                        }}
                        onChange={handleUser}
                        inputPlaceholder={trans('labels.contractor')}
                        ref={empoyeesDropdownRef}
                    />
                </div>
                :
                ''
            }

            <div className="col" data-id="2">
                <DateRange
                    startDate={props.data.date}
                    endDate={props.data.deadline}
                    onStartDateChange={(date) => {
                        props.handleSearch('date', date)
                    }} onEndDateChange={(date) => {
                        props.handleSearch('deadline', date)
                    }}
                />
            </div>
            <div className="col" data-id="4">
                <input
                    id="search"
                    type="search"
                    name="text"
                    value={props.data.text}
                    onChange={handleSearch}
                    placeholder={trans('labels.search')}
                />
            </div>
            {/* //NEW: Добавяне на филтър за флаг */}
            <div className="col" data-id="5">
                <FormControlLabel
                    control={
                        <Checkbox
                            id="flagged"
                            name="flagged"
                            checked={props.data.flagged === '1'}
                            onChange={e => props.handleSearch('flagged', e.target.checked ? '1' : '')}
                            size="small"
                        />
                    }
                    label={trans('labels.onlyFlagged')}
                />
            </div>
            <div className='col'>
                <button type='button' className='button-clear-filter' onClick={handleClearFilters}>
                    Изчистване
                </button>
            </div>
        </form>
    )
}

export default Filter